import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { GridCampaignSearchResponse } from '../models/campaign-management.model';

export const LoadData = createAction('[Campaign Management: Search]: Load Data');

export const GetSchemasSuccess = createAction(
  '[Campaign Management: Search]: Get Schemas Success',
  props<{ res: any }>(),
);

export const GetSchemasFailed = createAction(
  '[Campaign Management: Search]: Get Schemas Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCountriesSuccess = createAction(
  '[Campaign Management: Search]: Get Countries Success',
  props<{ res: any }>(),
);

export const GetCountriesFailed = createAction(
  '[Campaign Management: Search]: Get Countries Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetChannelsSuccess = createAction(
  '[Campaign Management: Search]: Get Channels Success',
  props<{ res: any }>(),
);

export const GetChannelsFailed = createAction(
  '[Campaign Management: Search]: Get Channels Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const PanelStatusChanged = createAction(
  '[Campaign Management: Search]: Panel Status Changed',
);

export const ChangeCampaignName = createAction(
  '[Campaign Management: Search]: Change Campaign Name',
  props<{ campaignName: string }>(),
);

export const ChangeSchema = createAction(
  '[Campaign Management: Search]: Change Schema',
  props<{ schemaId: number; schema: string }>(),
);

export const ChangeCountry = createAction(
  '[Campaign Management: Search]: Change Country',
  props<{ countryName: string; countryId: number }>(),
);

export const ChangeChannel = createAction(
  '[Campaign Management: Search]: Change Channel',
  props<{ channel: string }>(),
);

export const ChangeStartDate = createAction(
  '[Campaign Management: Search]: Change Start Date',
  props<{ startDate: Date; startDateFormat: string }>(),
);

export const ChangeEndDate = createAction(
  '[Campaign Management: Search]: Change End Date',
  props<{ endDate: Date; endDateFormat: string }>(),
);

export const ClearStartDate = createAction('[Campaign Management: Search]: Clear Start Date');

export const ClearEndDate = createAction('[Campaign Management: Search]: Clear End Date');

export const ClearOptions = createAction('[Campaign Management: Search]: Clear Options');

export const CampaignExecutionsCount = createAction(
  '[Campaign Management: Search]: Campaign Executions Count',
);

export const CampaignExecutionsCountSuccess = createAction(
  '[Campaign Management: Search]: Campaign Executions Count Success',
  props<{ res: number }>(),
);

export const CampaignExecutionsCountFailed = createAction(
  '[Campaign Management: Search]: Campaign Executions Count Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const OpenCEUpdateDateDialog = createAction(
  '[Campaign Management: Search]: Open Campaign Executions Update Date Dialog',
  props<{ row: GridCampaignSearchResponse; columnVal: string }>(),
);

export const CloseCEUpdateDateDialog = createAction(
  '[Campaign Management: Search]: Close Campaign Executions Update Date Dialog',
);

export const OpenCEUpdateCostDialog = createAction(
  '[Campaign Management: Search]: Open Campaign Executions Update Cost Dialog',
  props<{ row: GridCampaignSearchResponse; columnVal: string }>(),
);

export const CloseCEUpdateCostDialog = createAction(
  '[Campaign Management: Search]: Close Campaign Executions Update Cost Dialog',
);

export const OpenDownloadCRDialog = createAction(
  '[Campaign Management: Search]: Open Download Campaign Recipients Dialog',
  props<{ row: GridCampaignSearchResponse }>(),
);

export const CloseDownloadCRDialog = createAction(
  '[Campaign Management: Search]: Close Download Campaign Recipients Dialog',
);

export const CancelCampaignModal = createAction(
  '[Campaign Management: Search]: Cancel Campaign Modal',
  props<{ row: GridCampaignSearchResponse }>(),
);
